module.exports = __webpack_public_path__ + "static/media/team-regina.752fb867.jpg";